export default __webpack_public_path__ + "static/media/pantalla_erp.4c343875.png";